var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settings"}},[_c('div',{staticClass:"sub-title"},[_vm._v("\n        Current frame: "+_vm._s(_vm.$store.state.currentFrame + 1)+"\n    ")]),_c('playback'),_c('frame-settings'),_c('export')],1)}
var staticRenderFns = []

export { render, staticRenderFns }